export default {
	id: 'SIMPLE_CANCEL_OFFER_1M_2999_3M_1',
	providers: {
		paltaMap: {
			USD: 'simple_premium_1m_2999_3m_1_usd',
			EUR: 'simple_premium_1m_2999_3m_1_eur',
			GBP: 'simple_premium_1m_2999_3m_1_gbp',
			CAD: 'simple_premium_1m_4999_3m_1_cad',
			AUD: 'simple_premium_1m_49_99_3m_1_aud',
			DKK: 'simple_premium_1m_259_3m_10_dkk',
			SEK: 'simple_premium_1m_399_3m_10_sek',
			NOK: 'simple_premium_1m_399_3m_10_nok',
			BRL: 'simple_premium_1m_199_3m_5_brl',
			MXN: 'simple_premium_1m_499_3m_15_mxn',
			TRY: 'simple_premium_1m_999_3m_29_try',
			ARS: 'simple_premium_1m_39990_3m_1300_ars',
			COP: 'simple_premium_1m_119990_3m_4000_cop',
			CLP: 'simple_premium_1m_29990_3m_900_clp',
		},
		primer: 'prd_BnxbEHlEMgOG',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 3,
		intro_period_type: 'month',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 90,
		priceMap: {
			USD: 1,
			EUR: 1,
			GBP: 1,
			CAD: 1,
			AUD: 1,
			DKK: 10,
			SEK: 10,
			NOK: 10,
			BRL: 5,
			MXN: 15,
			TRY: 29,
			ARS: 1300,
			COP: 4000,
			CLP: 900,
		},
		originalPriceMap: {},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 29.99,
			EUR: 29.99,
			GBP: 29.99,
			CAD: 49.99,
			AUD: 49.99,
			DKK: 25.9,
			SEK: 39.9,
			NOK: 39.9,
			BRL: 19.9,
			MXN: 49.9,
			TRY: 99.9,
			ARS: 39990,
			COP: 119990,
			CLP: 29990,
		},
	},
}
